import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Button, Paper, Stack, Typography } from '@mui/material'
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import FuelLogForm from './FuelLogForm'

// Quick-add page for crew to log a refuel (header + menu, dashboard, search).
const RecordFuel = () => {
  const navigate = useNavigate()
  const [saved, setSaved] = useState(null)
  const [formKey, setFormKey] = useState(0)

  return (
    <Box maxWidth={760} mx="auto">
      <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: 3 }}>
        <Stack direction="row" spacing={1.5} alignItems="center" mb={2.5}>
          <LocalGasStationIcon color="anOrange" />
          <Box>
            <Typography variant="h5" fontWeight={800}>
              Record Fuel
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Log a refuel against a vehicle — separate from the VDI.
            </Typography>
          </Box>
        </Stack>
        {saved ? (
          <Stack spacing={2} alignItems="center" py={4} textAlign="center">
            <CheckCircleIcon color="success" sx={{ fontSize: 56 }} />
            <Typography variant="h6" fontWeight={800}>
              Fuel recorded
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {saved.litres} litres added to {saved.callSign}.
            </Typography>
            <Stack direction="row" spacing={1}>
              <Button
                variant="outlined"
                onClick={() => {
                  setSaved(null)
                  setFormKey((k) => k + 1)
                }}
              >
                Record another
              </Button>
              <Button variant="contained" onClick={() => navigate('/')}>
                Back to dashboard
              </Button>
            </Stack>
          </Stack>
        ) : (
          <FuelLogForm
            key={formKey}
            onSaved={(log, vehicle) =>
              setSaved({ litres: log.litres, callSign: vehicle?.callSign })
            }
          />
        )}
      </Paper>
    </Box>
  )
}

export default RecordFuel
